module.exports = __webpack_public_path__ + "static/media/handheld-icon.46e7158c.svg";